import script from "./ScheduleTicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleTicker.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleTicker.vue?vue&type=style&index=0&id=4c010620&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c010620"]])

export default __exports__